export const status = {
    NOT_REVIEWED: 0,
    AGAIN: 1,
    GOOD: 2,
    EASY: 3,
};